import {createContext, useContext, useEffect, useState} from "react";
import {getSubdomain} from "../utils/Utils";
import {useAuthHeader} from "../hooks/hooks";
import axios from "axios";

const ConfigContext = createContext();

export default ConfigContext;

export const ConfigProvider = ({ children }) => {
    const subdomain = getSubdomain()
    const {unauthenticatedHeaders} = useAuthHeader()
    const url = process.env.REACT_APP_BASE_URL + '/sp-businesses';
    const [config, setConfig] = useState({
        theme: "honved",
        usage_type: "website",
        payment_authorized: false,
        webshop_cash_payment: false,
        webshop_card_payment: false,
        mandatory_billing_details: false,
        popups: []
    })

    const unauthenticatedAPI = axios.create({
        baseURL: url,
        headers: unauthenticatedHeaders
    })

    useEffect(() => {
        unauthenticatedAPI.get(`get_config?subdomain=${subdomain}`).then(r => {
            setConfig(r?.data)
            console.log(r?.data)
        })
    }, [subdomain]);

    const contextData = {
        baseUrl: process.env.REACT_APP_BASE_URL,
        // baseUrl: 'https://back.dinobooking.hu',
        subdomain: subdomain,
        config: config
    }

    return <ConfigContext.Provider value={contextData}>{children}</ConfigContext.Provider>
}